/* NaturBox Shopify Theme - theme.js */

(function () {
  'use strict';

  // ============ i18n ============
  var T = {
    added: 'Sepete eklendi',
    removed: 'Sepetten kaldırıldı',
    updated: 'Sepet güncellendi',
    error: 'Bir hata oluştu',
    items: 'ürün',
    free_shipping_reached: 'Tebrikler! Kargo ücretsiz.',
    free_shipping_remaining: 'Ücretsiz kargo için {amount} kaldı'
  };
  if (document.documentElement.lang && document.documentElement.lang.indexOf('de') === 0) {
    T = {
      added: 'Zum Warenkorb hinzugefügt',
      removed: 'Aus dem Warenkorb entfernt',
      updated: 'Warenkorb aktualisiert',
      error: 'Ein Fehler ist aufgetreten',
      items: 'Artikel',
      free_shipping_reached: 'Glückwunsch! Kostenloser Versand.',
      free_shipping_remaining: 'Noch {amount} bis zum kostenlosen Versand'
    };
  }

  // ============ Yardımcı fonksiyonlar ============
  function showToast(message, type) {
    var container = document.querySelector('[data-toast-container]');
    if (!container) {
      container = document.createElement('div');
      container.className = 'toast-container';
      container.setAttribute('data-toast-container', '');
      document.body.appendChild(container);
    }
    var toast = document.createElement('div');
    toast.className = 'toast' + (type ? ' toast-' + type : '');
    var icon = '';
    if (type === 'success') {
      icon = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>';
    } else if (type === 'error') {
      icon = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';
    }
    toast.innerHTML = icon + '<span>' + message + '</span>';
    container.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 300);
    }, 2200);
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function escapeHtml(s) {
    if (!s) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }


  // ============ Dil Seçim Modali ============
(function() {
  var modal = document.getElementById('lang-modal');
  if (!modal) return;

  var chosen = localStorage.getItem('vira_lang');

  if (chosen) {
    // Daha önce seçim yapılmış
    if (chosen === 'tr' && window.location.pathname.indexOf('/tr') !== 0) {
      window.location.href = '/tr' + window.location.pathname;
    }
    return;
  }

  // İlk ziyaret — modali göster
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';

  modal.querySelectorAll('.lang-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var lang = btn.getAttribute('data-lang');
      localStorage.setItem('vira_lang', lang);
      modal.style.display = 'none';
      document.body.style.overflow = '';

      if (lang === 'tr' && window.location.pathname.indexOf('/tr') !== 0) {
        window.location.href = '/tr' + window.location.pathname;
      }
    });
  });
})();

  // window.NaturBox — global erişim
  window.NaturBox = {
    showToast: showToast,
    T: T,
    formatMoney: formatMoney,
    escapeHtml: escapeHtml
  };

  // ============ DOMContentLoaded — tek blok ============
  document.addEventListener('DOMContentLoaded', function () {

    // ============ Carousel arrows ============
    document.querySelectorAll('.nav-arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var carousel = btn.parentElement.querySelector('.carousel, .trends-carousel');
        if (!carousel) return;
        var dir = btn.classList.contains('next') ? 1 : -1;
        var card = carousel.querySelector(':scope > *');
        var step = card ? card.offsetWidth + 24 : 320;
        carousel.scrollBy({ left: step * dir, behavior: 'smooth' });
      });
    });

    // ============ Quantity buttons (product page) ============
    document.querySelectorAll('.qty:not(.qty-stepper)').forEach(function (qty) {
      var input = qty.querySelector('input');
      var minus = qty.querySelector('.minus');
      var plus = qty.querySelector('.plus');
      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
      });
    });

    // ============ Add to cart from product card ============
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-add[data-variant-id]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var card = btn.closest('.product-card');
      var stepper = card ? card.querySelector('.qty-stepper') : null;

      btn.disabled = true;
      btn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (item) {
        btn.classList.remove('is-loading');
        btn.hidden = true;
        btn.disabled = false;
        if (stepper) {
          stepper.hidden = false;
          var valueEl = stepper.querySelector('.qty-value');
          if (valueEl) valueEl.textContent = item.quantity || 1;
        }
        updateHeaderCart();
        openMiniCart();
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        showToast(T.error, 'error');
      });
    });

    // ============ Quantity stepper plus/minus on cards ============
    document.addEventListener('click', function (e) {
      var plusBtn = e.target.closest('.qty-stepper .qty-plus');
      var minusBtn = e.target.closest('.qty-stepper .qty-minus');
      if (!plusBtn && !minusBtn) return;

      e.preventDefault();
      e.stopPropagation();

      var stepper = (plusBtn || minusBtn).closest('.qty-stepper');
      if (!stepper || stepper.classList.contains('is-loading')) return;

      var variantId = stepper.getAttribute('data-variant-id');
      var valueEl = stepper.querySelector('.qty-value');
      var current = parseInt(valueEl.textContent, 10) || 1;
      var newQty = plusBtn ? current + 1 : current - 1;

      stepper.classList.add('is-loading');

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var lineIndex = -1;
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].variant_id == variantId) {
              lineIndex = i + 1;
              break;
            }
          }
          if (lineIndex === -1) {
            if (newQty > 0) {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: newQty })
              }).then(function (r) { return r.json(); });
            }
            return Promise.resolve(null);
          }
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: lineIndex, quantity: Math.max(0, newQty) })
          }).then(function (r) { return r.json(); });
        })
        .then(function () {
          stepper.classList.remove('is-loading');
          if (newQty <= 0) {
            stepper.hidden = true;
            var card = stepper.closest('.product-card');
            var addBtn = card ? card.querySelector('.cart-add') : null;
            if (addBtn) addBtn.hidden = false;
            valueEl.textContent = '1';
          } else {
            valueEl.textContent = newQty;
          }
          updateHeaderCart();

          // Ürün kartındaki + ile adet artırıldığında mini sepeti de aç.
          // - ile azaltıldığında mini sepeti sadece arka planda güncelle.
          if (plusBtn && newQty > 0) {
            openMiniCart();
          } else {
            renderMiniCart();
          }
        })
        .catch(function () {
          stepper.classList.remove('is-loading');
          showToast(T.error, 'error');
        });
    });

    // ============ Update header cart count + total ============
    function updateHeaderCart() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var countEl = document.querySelector('.cart-count');
          var cartBtn = document.querySelector('[data-mini-cart-open]');
          if (cart.item_count > 0) {
            if (countEl) {
              countEl.textContent = cart.item_count;
            } else if (cartBtn) {
              var span = document.createElement('span');
              span.className = 'cart-count';
              span.textContent = cart.item_count;
              cartBtn.appendChild(span);
            }
          } else {
            if (countEl) countEl.remove();
          }
          var totalEls = document.querySelectorAll('.cart-total-inline, .cart-total');
          totalEls.forEach(function (totalEl) {
            totalEl.textContent = formatMoney(cart.total_price);
          });
        });
    }

    // ============ Sync cards on load ============
    function syncCardsWithCart() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cart.items.forEach(function (item) {
            document.querySelectorAll('.product-card[data-variant-id="' + item.variant_id + '"]').forEach(function (card) {
              var addBtn = card.querySelector('.cart-add');
              var stepper = card.querySelector('.qty-stepper');
              if (addBtn && stepper) {
                addBtn.hidden = true;
                stepper.hidden = false;
                var valueEl = stepper.querySelector('.qty-value');
                if (valueEl) valueEl.textContent = item.quantity;
              }
            });
          });
        })
        .catch(function () {});
    }
    syncCardsWithCart();

    // ============ Mini cart drawer ============
    var miniCart = document.querySelector('[data-mini-cart]');
    var miniCartBody = document.querySelector('[data-mini-cart-lines]');
    var miniCartEmpty = document.querySelector('[data-mini-cart-empty]');
    var miniCartFooter = document.querySelector('[data-mini-cart-footer]');
    var miniCartSubtotal = document.querySelector('[data-mini-cart-subtotal]');
    var miniCartPosition = document.querySelector('[data-mini-cart-position]');
    var miniCartSummary = document.querySelector('[data-mini-cart-summary]');
    var summaryText = document.querySelector('[data-summary-text]');
    var progressBar = document.querySelector('[data-progress-bar]');

    function openMiniCart() {
      if (!miniCart) return;
      renderMiniCart();
      miniCart.classList.add('is-open');
      ensureOverlay();
      document.body.style.overflow = 'hidden';
    }
    function closeMiniCart() {
      if (!miniCart) return;
      miniCart.classList.remove('is-open');
      var ov = document.querySelector('.drawer-overlay.is-open');
      if (ov && !document.querySelector('.mobile-drawer.is-open')) {
        ov.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
    function ensureOverlay() {
      var ov = document.querySelector('[data-drawer-overlay]');
      if (ov) ov.classList.add('is-open');
    }

    function renderMiniCart() {
      if (!miniCart) return;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (miniCartPosition) {
            miniCartPosition.textContent = cart.item_count + ' ' + T.items;
          }
          if (cart.item_count === 0) {
            if (miniCartEmpty) miniCartEmpty.style.display = '';
            if (miniCartBody) miniCartBody.innerHTML = '';
            if (miniCartFooter) miniCartFooter.hidden = true;
            if (miniCartSummary) miniCartSummary.hidden = true;
            return;
          }
          if (miniCartEmpty) miniCartEmpty.style.display = 'none';
          if (miniCartFooter) miniCartFooter.hidden = false;

          var threshold = parseInt(miniCart.getAttribute('data-free-ship-threshold'), 10) || 0;
          if (threshold > 0 && miniCartSummary) {
            miniCartSummary.hidden = false;
            var progress = Math.min(100, (cart.total_price / threshold) * 100);
            if (progressBar) progressBar.style.width = progress + '%';
            if (summaryText) {
              if (cart.total_price >= threshold) {
                summaryText.textContent = T.free_shipping_reached;
              } else {
                var remaining = threshold - cart.total_price;
                summaryText.textContent = T.free_shipping_remaining.replace('{amount}', formatMoney(remaining));
              }
            }
          }

          var html = '';
          cart.items.forEach(function (item, idx) {
            var lineNum = idx + 1;
            html += '<div class="mini-cart-line" data-line="' + lineNum + '" data-variant-id="' + item.variant_id + '">';
            html += '  <div class="mini-cart-line-img">';
            if (item.image) {
              html += '    <img src="' + item.image.replace(/\.(jpg|jpeg|png|gif|webp)/, '_200x.$1') + '" alt="' + escapeHtml(item.product_title) + '">';
            }
            html += '  </div>';
            html += '  <div class="mini-cart-line-info">';
            html += '    <div class="mini-cart-line-title">' + escapeHtml(item.product_title) + '</div>';
            if (item.variant_title && item.variant_title !== 'Default Title') {
              html += '    <div class="mini-cart-line-variant">' + escapeHtml(item.variant_title) + '</div>';
            }
            html += '    <div class="mini-cart-qty-select">';
            html += '      <button type="button" class="mc-minus" aria-label="−"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>';
            html += '      <span class="val">' + item.quantity + '</span>';
            html += '      <button type="button" class="mc-plus" aria-label="+"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>';
            html += '    </div>';
            html += '  </div>';
            html += '  <div class="mini-cart-line-right">';
            html += '    <button type="button" class="mini-cart-line-remove" aria-label="Kaldır" data-remove>';
            html += '      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
            html += '    </button>';
            html += '    <div class="mini-cart-line-price">' + formatMoney(item.final_line_price) + '</div>';
            html += '  </div>';
            html += '</div>';
          });
          if (miniCartBody) miniCartBody.innerHTML = html;
          if (miniCartSubtotal) miniCartSubtotal.textContent = formatMoney(cart.total_price);
        });
    }

    document.querySelectorAll('[data-mini-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openMiniCart();
      });
    });
    document.querySelectorAll('[data-mini-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', closeMiniCart);
    });

    document.addEventListener('click', function (e) {
      var line = e.target.closest('.mini-cart-line');
      if (!line) return;

      var lineNum = parseInt(line.getAttribute('data-line'), 10);
      var variantId = line.getAttribute('data-variant-id');

      if (e.target.closest('.mc-plus') || e.target.closest('.mc-minus')) {
        e.preventDefault();
        var valEl = line.querySelector('.val');
        var current = parseInt(valEl.textContent, 10) || 1;
        var newQty = e.target.closest('.mc-plus') ? current + 1 : Math.max(0, current - 1);
        updateLine(lineNum, newQty, variantId);
        return;
      }

      if (e.target.closest('[data-remove]')) {
        e.preventDefault();
        updateLine(lineNum, 0, variantId);
        return;
      }
    });

    function updateLine(lineNum, quantity, variantId) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineNum, quantity: quantity })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        renderMiniCart();
        updateHeaderCart();
        if (variantId) {
          document.querySelectorAll('.product-card[data-variant-id="' + variantId + '"]').forEach(function (card) {
            var stepper = card.querySelector('.qty-stepper');
            var addBtn = card.querySelector('.cart-add');
            var valueEl = stepper ? stepper.querySelector('.qty-value') : null;
            if (quantity <= 0) {
              if (stepper) stepper.hidden = true;
              if (addBtn) addBtn.hidden = false;
              if (valueEl) valueEl.textContent = '1';
            } else {
              if (valueEl) valueEl.textContent = quantity;
            }
          });
        }
      })
      .catch(function () { showToast(T.error, 'error'); });
    }

    // ============ Heart toggle ============
   // ============ Wishlist / Heart toggle ============
function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem('wishlist_products')) || [];
  } catch (e) {
    return [];
  }
}

function saveWishlist(items) {
  localStorage.setItem('wishlist_products', JSON.stringify(items));
}

function setHeartState(btn, active) {
  btn.classList.toggle('active', active);

  var svg = btn.querySelector('svg');
  if (!svg) return;

  if (active) {
    svg.setAttribute('fill', '#b03e52');
    svg.setAttribute('stroke', '#b03e52');
  } else {
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
  }
}

function initWishlistHearts() {
  var wishlist = getWishlist();

  document.querySelectorAll('.heart-btn[data-product-id]').forEach(function (btn) {
    var productId = btn.getAttribute('data-product-id');
    setHeartState(btn, wishlist.indexOf(productId) !== -1);
  });
}

document.addEventListener('click', function (e) {
  var btn = e.target.closest('.heart-btn[data-product-id]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  var productId = btn.getAttribute('data-product-id');
  var wishlist = getWishlist();
  var index = wishlist.indexOf(productId);

  if (index === -1) {
    wishlist.push(productId);
    setHeartState(btn, true);
  } else {
    wishlist.splice(index, 1);
    setHeartState(btn, false);
  }

  saveWishlist(wishlist);
});

initWishlistHearts();

function updateWishlistCount() {
  var ids = getWishlist();
  var el = document.querySelector('[data-wishlist-count]');
  if (!el) return;
  el.textContent = ids.length;
  el.hidden = ids.length === 0;
}
updateWishlistCount();

    // ============ Product gallery ============
    document.querySelectorAll('.product-gallery').forEach(function (gallery) {
      var main = gallery.querySelector('.main-image');
      var thumbs = gallery.querySelectorAll('.thumbs img');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (main) main.src = thumb.dataset.large || thumb.src;
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
        });
      });
    });

    // ============ KoRo product page gallery ============
    var koroThumbs = document.querySelectorAll('.product-koro-thumb');
    var koroImages = document.querySelectorAll('.koro-main-img');
    if (koroThumbs.length) {
      koroThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.getAttribute('data-thumb');
          koroThumbs.forEach(function (t) { t.classList.remove('is-active'); });
          koroImages.forEach(function (img) { img.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          var targetImg = document.querySelector('.koro-main-img[data-image="' + idx + '"]');
          if (targetImg) targetImg.classList.add('is-active');
        });
      });

      var variantRadios = document.querySelectorAll('.koro-variant-radio input[type="radio"]');
      var hiddenIdInput = document.querySelector('.koro-product-form input[name="id"]');
      variantRadios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          document.querySelectorAll('.koro-variant-radio').forEach(function (lbl) {
            lbl.classList.remove('is-selected');
          });
          radio.closest('.koro-variant-radio').classList.add('is-selected');
          if (hiddenIdInput) hiddenIdInput.value = radio.value;
        });
      });
    }

    // ============ Locale form auto submit ============
    document.querySelectorAll('.locale-form select').forEach(function (sel) {
      sel.addEventListener('change', function () {
        // Kullanıcı üst menüden dili elle değiştirirse ilk dil seçimi tercihini de güncelle.
        // Aksi halde daha önce Türkçe seçildiyse theme.js tekrar /tr yoluna yönlendiriyordu.
        if (sel.name === 'locale_code') {
          localStorage.setItem('vira_lang', sel.value);
        }
        sel.form.submit();
      });
    });

    // ============ Search dropdown toggle ============
    var searchForm = document.querySelector('[data-search-form]');
    if (searchForm && window.innerWidth <= 980) {
      searchForm.classList.add('is-hidden');
    }
    document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!searchForm) return;
        searchForm.classList.toggle('is-hidden');
        if (!searchForm.classList.contains('is-hidden')) {
          var input = searchForm.querySelector('input');
          if (input) setTimeout(function () { input.focus(); }, 50);
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!searchForm || window.innerWidth > 980) return;
      if (searchForm.classList.contains('is-hidden')) return;
      if (!searchForm.contains(e.target) && !e.target.closest('[data-search-toggle]')) {
        searchForm.classList.add('is-hidden');
      }
    });

    // ============ Sticky header scroll shadow ============
    var siteHeader = document.querySelector('.site-header');
    if (siteHeader) {
      window.addEventListener('scroll', function () {
        siteHeader.classList.toggle('is-scrolled', window.scrollY > 4);
      }, { passive: true });
    }

    // ============ Floating contact drawer ============
    var contactDrawer = document.querySelector('[data-contact-drawer]');
    var overlay = document.querySelector('[data-drawer-overlay]');
    var mobileDrawer = document.querySelector('[data-drawer]');

    function openContact() {
      if (!contactDrawer) return;
      contactDrawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function openDrawer() {
      if (!mobileDrawer || !overlay) return;
      mobileDrawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeAllDrawers() {
      if (mobileDrawer) mobileDrawer.classList.remove('is-open');
      if (miniCart) miniCart.classList.remove('is-open');
      if (contactDrawer) contactDrawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-contact-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openContact(); });
    });
    document.querySelectorAll('[data-contact-close]').forEach(function (btn) {
      btn.addEventListener('click', closeAllDrawers);
    });
    document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });
    document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeAllDrawers);
    });
    if (overlay) overlay.addEventListener('click', closeAllDrawers);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDrawers();
    });

    // ============ Hero Slider ============
    document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
      var slides = slider.querySelectorAll('[data-slide]');
      var dots = slider.querySelectorAll('[data-slide-to]');
      var prevBtn = slider.querySelector('.hero-slider-prev');
      var nextBtn = slider.querySelector('.hero-slider-next');
      var current = 0;
      var total = slides.length;
      var autoplayInterval = null;

      if (total <= 1) return;

      function goToSlide(index) {
        if (slides[current]) slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = index;
        if (current >= total) current = 0;
        if (current < 0) current = total - 1;
        if (slides[current]) slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function startAutoplay() {
        stopAutoplay();
        autoplayInterval = setInterval(function () { goToSlide(current + 1); }, 5000);
      }
      function stopAutoplay() {
        if (autoplayInterval) { clearInterval(autoplayInterval); autoplayInterval = null; }
      }

      if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); goToSlide(current + 1); startAutoplay(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); goToSlide(current - 1); startAutoplay(); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var target = parseInt(dot.getAttribute('data-slide-to'), 10);
          if (isNaN(target)) return;
          stopAutoplay();
          goToSlide(target);
          startAutoplay();
        });
      });

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
      startAutoplay();
    });

   
    // ============ Quick View ============
var modal = document.getElementById('quick-view-modal');
var modalBody = document.querySelector('[data-quick-view-body]');
var quickViewCache = {};

function getLangPrefix() {
  return window.location.pathname.indexOf('/tr') === 0 ? '/tr' : '';
}

function getLocalizedProductUrl(productUrl) {
  var langPrefix = getLangPrefix();
  if (!productUrl) return langPrefix || '/';
  if (!langPrefix) return productUrl;
  if (productUrl.indexOf(langPrefix + '/') === 0) return productUrl;
  return langPrefix + productUrl;
}

function preloadQuickView(handle) {
  var langPrefix = getLangPrefix();
  var cacheKey = langPrefix + ':' + handle;

  if (!handle) return Promise.resolve(null);
  if (quickViewCache[cacheKey]) return quickViewCache[cacheKey];

  quickViewCache[cacheKey] = fetch(langPrefix + '/products/' + handle + '.js')
    .then(function (r) {
      if (!r.ok) throw new Error('Ürün bulunamadı');
      return r.json();
    })
    .then(function (product) {
      if (product.images && product.images[0]) {
        var img = new Image();
        img.src = product.images[0];
      }
      return product;
    })
    .catch(function () {
      delete quickViewCache[cacheKey];
      return null;
    });

  return quickViewCache[cacheKey];
}

// Desktop hover preload
document.addEventListener('mouseover', function (e) {
  var btn = e.target.closest('.quick-view-btn');
  if (!btn) return;

  var handle = btn.getAttribute('data-product-handle');
  preloadQuickView(handle);
});

// Mobile touch preload
document.addEventListener('touchstart', function (e) {
  var btn = e.target.closest('.quick-view-btn');
  if (!btn) return;

  var handle = btn.getAttribute('data-product-handle');
  preloadQuickView(handle);
}, { passive: true });

if (modal && modalBody) {
  var currentQty = 1;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-view-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    openQuickView(handle);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-quick-view-close]')) closeQuickView();

    var overlayEl = modal.querySelector('.quick-view-overlay');
    if (overlayEl && e.target === overlayEl) closeQuickView();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
      closeQuickView();
    }
  });

  function openQuickView(handle) {
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    modalBody.innerHTML =
      '<div class="quick-view-loading">' +
        '<div class="quick-view-skeleton quick-view-skeleton-image"></div>' +
        '<div class="quick-view-skeleton-content">' +
          '<div class="quick-view-skeleton-line w-70"></div>' +
          '<div class="quick-view-skeleton-line w-40"></div>' +
          '<div class="quick-view-skeleton-line w-90"></div>' +
          '<div class="quick-view-skeleton-line w-80"></div>' +
        '</div>' +
      '</div>';

    var langPrefix = getLangPrefix();
    var cacheKey = langPrefix + ':' + handle;
    var productPromise = quickViewCache[cacheKey] || preloadQuickView(handle);

    productPromise
      .then(function (product) {
        if (!product) throw new Error('Ürün bulunamadı');
        currentQty = 1;
        renderQuickView(product);
      })
      .catch(function (err) {
        modalBody.innerHTML =
          '<div style="padding:60px;text-align:center;color:var(--berry);">Hata: ' +
          escapeHtml(err.message) +
          '</div>';
      });
  }

  function closeQuickView() {
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function renderQuickView(product) {
    var variant = product.variants[0];
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    var priceHtml = onSale
      ? '<span class="sale">' + formatMoney(variant.price) + '</span><span class="old">' + formatMoney(variant.compare_at_price) + '</span>'
      : formatMoney(variant.price);

    var bioBadge = '';
    var tags = product.tags || [];

    if (tags.some(function (t) { return String(t).toLowerCase() === 'bio'; })) {
      bioBadge =
        '<span class="badge-tag badge-bio" style="position:static;display:inline-flex;margin-bottom:12px;">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
            '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>' +
            '<path d="M8 12l3 3 5-5" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg> BIO' +
        '</span>';
    }

    var imageSrc = product.images && product.images[0] ? product.images[0] : '';
    var productUrl = getLocalizedProductUrl(product.url);

    modalBody.innerHTML =
      '<div class="quick-view-inner">' +
        '<div class="quick-view-image">' +
          '<img ' +
            'src="' + imageSrc + '" ' +
            'alt="' + escapeHtml(product.title) + '" ' +
            'loading="eager" ' +
            'fetchpriority="high" ' +
            'decoding="async" ' +
          '>' +
        '</div>' +

        '<div class="quick-view-info">' +
          bioBadge +
          '<h2 class="quick-view-title">' + escapeHtml(product.title) + '</h2>' +
          '<div class="quick-view-price">' + priceHtml + '</div>' +
          '<div class="quick-view-description">' +
            (product.description ? product.description.replace(/<[^>]*>/g, '').substring(0, 200) + '...' : '') +
          '</div>' +

          '<div class="quick-view-actions">' +
            '<div class="quick-view-qty">' +
              '<button type="button" class="qv-qty-minus" aria-label="Azalt">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
              '</button>' +
              '<input type="text" class="qv-qty-value" value="1" readonly>' +
              '<button type="button" class="qv-qty-plus" aria-label="Artır">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
              '</button>' +
            '</div>' +

            '<button type="button" class="quick-view-add-btn" data-variant-id="' + variant.id + '">' +
              'SEPETE EKLE' +
            '</button>' +
          '</div>' +

          '<a href="' + productUrl + '" class="quick-view-link">Ürün sayfasına git →</a>' +
        '</div>' +
      '</div>';

    var qvImg = modalBody.querySelector('.quick-view-image img');
    if (qvImg) {
      if (qvImg.complete) {
        qvImg.classList.add('is-loaded');
      } else {
        qvImg.addEventListener('load', function () {
          qvImg.classList.add('is-loaded');
        }, { once: true });
      }
    }

    var minusBtn = modalBody.querySelector('.qv-qty-minus');
    var plusBtn = modalBody.querySelector('.qv-qty-plus');
    var qtyInput = modalBody.querySelector('.qv-qty-value');
    var addBtn = modalBody.querySelector('.quick-view-add-btn');

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        if (currentQty > 1) {
          currentQty--;
          qtyInput.value = currentQty;
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        currentQty++;
        qtyInput.value = currentQty;
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var vid = addBtn.getAttribute('data-variant-id');

        addBtn.disabled = true;
        addBtn.textContent = 'Ekleniyor...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: currentQty })
        })
        .then(function (r) {
          if (!r.ok) throw new Error('Hata');
          return r.json();
        })
        .then(function () {
          addBtn.textContent = '✓ EKLENDİ';
          addBtn.style.background = '#2d4a2b';

          showToast(T.added, 'success');
          updateHeaderCart();
          openMiniCart();

          setTimeout(closeQuickView, 800);
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'SEPETE EKLE';
          showToast(T.error, 'error');
        });
      });
    }
  }
}

    // Global erişim
    window.NaturBox.updateHeaderCart = updateHeaderCart;
    window.NaturBox.renderMiniCart = renderMiniCart;
    window.NaturBox.openMiniCart = openMiniCart;

  }); // DOMContentLoaded sonu

})();